import React from 'react';

import { DEMO_PRIVACY_MODE_STORAGE_KEY } from 'src/constants/demoPrivacyMode';
import { useCurrentUserPermissions } from 'src/hooks/user';

import { DemoPrivacyModeContext } from './DemoPrivacyModeContext';

const readStoredDemoPrivacyMode = (): boolean => {
  return localStorage.getItem(DEMO_PRIVACY_MODE_STORAGE_KEY) === 'true';
};

export const DemoPrivacyModeProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { hasPlatformRoles } = useCurrentUserPermissions();
  const [isDemoPrivacyModeEnabled, setIsDemoPrivacyModeEnabled] =
    React.useState(readStoredDemoPrivacyMode);

  const setDemoPrivacyModeEnabled = React.useCallback((enabled: boolean) => {
    setIsDemoPrivacyModeEnabled(enabled);
    localStorage.setItem(DEMO_PRIVACY_MODE_STORAGE_KEY, String(enabled));
  }, []);

  const contextValue = React.useMemo(
    () => ({
      isDemoPrivacyModeEnabled: hasPlatformRoles && isDemoPrivacyModeEnabled,
      isDemoPrivacyModeAvailable: hasPlatformRoles,
      setDemoPrivacyModeEnabled,
    }),
    [hasPlatformRoles, isDemoPrivacyModeEnabled, setDemoPrivacyModeEnabled],
  );

  return <DemoPrivacyModeContext value={contextValue}>{children}</DemoPrivacyModeContext>;
};
